import { Permission } from "@/services/Permissions";

export const ExternalUserPermissions = [
  Permission.RTRACKER_OPTS_COUNTRY_OVERVIEW_VIEW,
  Permission.RTRACKER_REPORT_VIEW_ONLY,
  Permission.ACCOUNT_VIEW_ONLY,
  Permission.BASIC_ACCESS,
  Permission.CUSTOMER_VIEW_ONLY,
  Permission.RTRACKER_OPTS_CONFIG_DEFAULT_MESSAGES_VIEW
];

export const ViewOnlyUserPermissions = [
  Permission.RTRACKER_OPTS_COUNTRY_OVERVIEW_VIEW,
  Permission.RTRACKER_REPORT_VIEW_ONLY,
  Permission.ACCOUNT_VIEW_ONLY,
  Permission.BASIC_ACCESS,
  Permission.RTRACKER_OPTS_CONFIG_DEFAULT_MESSAGES_VIEW
];
